import React, { useContext, useCallback } from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HeaderContador from './HeaderContador';
import Roles from '../../config/roles';
import NotesService from '../../services/notes.service';
import { StateContext } from '../context/StateProvider';
import { INCIDENCIA_ESTADO_VALOR } from '../../config/constants';

// CSV de estados no cerrados para el filtro del API (abierta + en proceso)
const ESTADOS_NO_CERRADOS = `${INCIDENCIA_ESTADO_VALOR.ABIERTA}`;

/**
 * Icono del header con el número de incidencias no cerradas del ejercicio actual; navega a /incidencias
 */
export default function HeaderIncidencias({ compacto = false }) {
    const { state } = useContext(StateContext);

    // useCallback con el ejercicio como dependencia: al cambiar el año en el header,
    // HeaderContador reinicia su intervalo y recarga el contador inmediatamente
    const cargarIncidenciasAbiertas = useCallback(async () => {
        const count = await NotesService.countIncidencias({
            estado: ESTADOS_NO_CERRADOS,
            ejercicio: state.year,
        });

        return Number(count) || 0;
    }, [state.year]);

    return (
        <HeaderContador
            icon={ReportProblemIcon}
            ruta="/incidencias"
            titulo="incidencias abiertas"
            roles={[Roles.ADMIN.role]}
            cargarContador={cargarIncidenciasAbiertas}
            compacto={compacto}
            triggerKey="incidencias"
        />
    );
}
